import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, TextField } from "@mui/material";
import axios from "axios";
import { getBlockchainNodeUrl } from "../globals/const";
import LocateLand from "../components/LocateLand";
import { useLocation } from "react-router-dom";

const useStyles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ViewLandNFT() {
  const classes = useStyles;
  let urlQuery = useQuery();
  console.log("urlQuery", urlQuery);
  const token_code = urlQuery.get("token_code");
  console.log("token_code", token_code);

  const [tokenData, setTokenData] = useState({
    farm_name: "",
    area: "",
    regulator: "",
    pin_code: "",
    irrigation_source: "",
  });
  const [location, setLocation] = useState({});
  const [path, setPath] = useState([{ lat: 0, lng: 0 }]);

  const loadNFT = async () => {
    let res = await axios.get(
      getBlockchainNodeUrl() + "/get-token?token_code=" + token_code,
    );
    let nftData = res.data.token_attributes;
    nftData = JSON.parse(nftData);
    console.log(nftData);
    setTokenData(nftData);
    setPath(nftData.polygon);

    setLocation({
      latitude: nftData.polygon[0]["lat"],
      longitude: nftData.polygon[0]["lng"],
    });
  };

  useEffect(() => {
    loadNFT();
  }, [token_code]);

  return (
    <Container maxWidth="xs">
      <div className={classes.mainContent}>
        <Grid
          container
          // spacing={1}
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <Typography variant="h5">View Farm</Typography>

          <TextField
            margin="normal"
            fullWidth
            label="Farm Name"
            disabled
            value={tokenData.farm_name}
          />
          <TextField
            margin="normal"
            fullWidth
            label="Area(acres)"
            disabled
            value={tokenData.area}
          />
          <TextField
            margin="normal"
            fullWidth
            label="Governing Body"
            disabled
            value={tokenData.regulator}
          />
          <TextField
            margin="normal"
            fullWidth
            label="PIN Code"
            disabled
            value={tokenData.pin_code}
          />
          <TextField
            margin="normal"
            fullWidth
            label="Irrigation Source"
            disabled
            value={tokenData.irrigation_source}
          />

          <LocateLand
            center={{
              lat: location["latitude"],
              lng: location["longitude"],
            }}
            setCenter={() => {}}
            path={path}
            setPath={() => {}}
            editable={false}
          />
          {/* Add an image with QR code to the current page */}
          <img
            width={300}
            height={300}
            src={`https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${window.location.href}`}
            alt=""
          />

          {/* <Button
            style={{ marginTop: 10 }}
            variant="contained"
            size="small"
            color="primary"
            onClick={loadNFT}>Create NFT
          </Button> */}
        </Grid>
      </div>
    </Container>
  );
}
